<template>
  <section>
    <a :href="indexData.index_top_pull[0].url" target="_blank" rel="noopener noreferrer">
      <img :src="indexData.index_top_pull[0].src" alt srcset class="topguanggao" />
    </a>
    <Header
      :indexData="indexData"
      :userInfo="userInfo"
      :keyword="keyword"
      :cartnum="cartnum"
      @my-event="getMyEvent"
    >></Header>
    <div class="container goodslistPage">
      <div class="path">
        <a href="#/">首页</a>
        <i class="iconfont icon-right"></i>
        <!-- {{product_list.categoryname||product_list.shopname||'分类'}} -->
        <a
          href="javascript:;"
          @click="navclass(item.id)"
          v-for="(item,key) in product_list.categorypath"
          :key="key"
        >
          {{item.name}}
          <i class="iconfont icon-right"></i>
        </a>
        <!-- <a href="javascript:;" class="keyword"> <i class="iconfont icon-cha" style="font-size:14px;"></i></a> -->
      </div>
      <div class="product-screen">
        <div class="item" v-if="attr.length>0">
          <div class="hd">已选</div>
          <div class="bd flex" style="height:40px">
            <ul class="clearlist flex">
              <li
                @click="changesx(item.index,item.id,item.name,'detele')"
                class="selectedBrand color-primary"
                v-for="(item,index) in attr"
                :key="index"
              >
                <span>{{item.name}}</span>
                <span class="iconfont icon-cha color-primary"></span>
              </li>
            </ul>
          </div>
        </div>
        <div class="item" v-for="(item,index) in product_list.attrlist" :key="index">
          <div class="hd">{{item.name}}</div>
          <div class="bd flex">
            <ul class="clearlist flex">
              <el-radio-group v-model="item.ids" class>
                <el-radio
                  :value="index+'_'+item_i.id+'_'+item_i.name"
                  :label="index+'_'+item_i.id+'_'+item_i.name"
                  v-for="(item_i,index_i) in item.values"
                  :key="index_i"
                  :class="item_i.id==''?'colo-primary':''"
                >
                  <span @click="changesx(index,item_i.id,item_i.name)">{{item_i.name}}</span>
                </el-radio>
              </el-radio-group>
            </ul>
          </div>
          <div class="ft">
            <a href="javascript:;" class="openbtn">
              更多
              <i class="iconfont icon-down"></i>
            </a>
            <a href="javascript:;" class="closebtn" style="display: none;">
              收起
              <i class="iconfont icon-up"></i>
            </a>
          </div>
        </div>
      </div>
      <div class="pxbox">
        <div class="paixu">
          <a href="javascript:;" @click="changeSort('')" :class="sort==''?'active':''">
            综合
            <i class="arr down"></i>
          </a>
          <a href="javascript:;" @click="changeSort(2)" class="active" v-if="sort==1">
            销量
            <i class="arr down"></i>
          </a>
          <a href="javascript:;" @click="changeSort(1)" class="active" v-if="sort==2">
            销量
            <i class="arr up"></i>
          </a>
          <a href="javascript:;" @click="changeSort(1)" class v-if="sort==3||sort==4">
            销量
            <i class="arr down"></i>
          </a>
          <a href="javascript:;" @click="changeSort(1)" class v-if="sort==''">
            销量
            <i class="arr down"></i>
          </a>
          <a href="javascript:;" @click="changeSort(4)" class="active" v-if="sort==3">
            价格
            <i class="arr02 down"></i>
          </a>
          <a href="javascript:;" @click="changeSort(3)" class="active" v-if="sort==4">
            价格
            <i class="arr02 up"></i>
          </a>
          <a href="javascript:;" @click="changeSort(3)" class v-if="sort==1||sort==2">
            价格
            <i class="arr02 down"></i>
          </a>
          <a href="javascript:;" @click="changeSort(3)" class v-if="sort==''">
            价格
            <i class="arr02 down"></i>
          </a>
        </div>
        <div class="fenye">
          <span class="fl" style=" margin-right: 20px;">
            共
            <strong>{{product_list.total}}</strong>件商品
          </span>
        </div>
      </div>
      <div class="product-list">
        <ul class="clearlist clearfix">
          <li v-for="(item,index) in product_list.data" :key="index">
            <div class="img">
              <a :href="'product/'+item.id+'.html'" target="_blank">
                <el-image :src="item.indexpic" lazy></el-image>
              </a>
            </div>
            <div class="jiage">
              <span class="xianjia fl">¥{{item.price}}</span>
              <span class="fr sold">售出{{item.sold+item.soldinit+item.solds}}件</span>
            </div>
            <div>
              <a
                class="tit ellipsis-2"
                :href="'product/'+item.id+'.html'"
                target="_blank"
                v-html="item.title"
              ></a>
            </div>
            <div class="shopname ellipsis" v-if="item.showsign">
              <span>{{item.issign?'签约商品':'普通商品'}}</span>
            </div>
            <div class="tags">
              <span class="tag01">自营</span>
              <span class="tag02">热卖</span>
            </div>
            <div class="addCar flex ju-be">
              <el-input-number
                class="jishuqi"
                v-model="item.num"
                :min="1"
                :max="1000"
                size="small"
                label="描述文字"
              ></el-input-number>
              <el-button type="primary" round size="small" @click="addCart(item)">加入购物车</el-button>
            </div>
          </li>
        </ul>
      </div>
      <el-pagination
        class="fenye"
        background
        layout="prev, pager, next"
        :page-size="product_list.per_page"
        @current-change="currentPage"
        :total="product_list.total"
      ></el-pagination>
      <div style="font-size: 18px; font-weight: bold;">猜你喜欢</div>
      <div class="product-list">
        <ul class="clearlist clearfix">
          <li class="item" v-for="(item,index) in cainixihuan.data" :key="index">
            <a :href="'product/'+item.id+'.html'" target="_blank">
              <div class="img">
                <!-- <img :src="item.indexpic" /> -->
                <el-image :src="item.indexpic" lazy></el-image>
              </div>
              <div class="tit ellipsis-2">{{item.title}}</div>
              <div class="price">
                <span class="xianjia color-red">¥{{item.price}}</span>
              </div>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <Footer :indexData="indexData"></Footer>
  </section>
</template>

<script>
import Header from "../components/header";
import Footer from "../components/footer";

// let total = 10;
export default {
  components: {
    Header,
    Footer
  },
  name: "index",
  data() {
    return {
      categoryid: getParameterByName("categoryid"),
      shopid: getParameterByName("shopid"),
      pid: getParameterByName("pid"),
      keyword: decodeURI(getParameterByName("keyword")),
      hashurl: "",
      page: 1,
      size: 10,
      total: 20,
      cartnum: 0,
      autotroph: sessionStorage.autotroph,
      sortList: [
        { value: 1, name: "销量降序" },
        { value: 2, name: "销量升序" },
        { value: 3, name: "价格降序" },
        { value: 4, name: "价格升序" }
      ],
      sort: "",
      guid: sessionStorage.guid,
      product_list: { total: 10 }, //产品列表
      indexData: { index_top_pull: [{ url: "", src: "" }] },
      userInfo: {},
      cainixihuan: {},
      attr: []
    };
  },
  watch: {
    categoryid() {
      this.$router.push(`/goodsList?categoryid=${this.categoryid}`);
      this.getProduct_list();
    },
    keyword() {
      this.getProduct_list();
    },
    page(val) {
      this.getProduct_list();
    }
  },
  methods: {
    changesx(index, id, name, type) {
      if (!type) {
        if (!this.attr[index]) {
          this.attr.push({ id, name, index });
        } else {
          this.attr[index] = { id, name, index };
        }
      } else {
        this.attr.splice(index, 1);
        this.attr.map((item, item_index) => {
          if (item.id == id) {
            this.attr.splice(item_index, 1);
          }
        });
      }

      this.getProduct_list();
    },
    getMyEvent(item) {
      if (item.categoryid || item.categoryid == "") {
        this.categoryid = item.categoryid;
      }
      if (item.keyword) {
        this.keyword = item.keyword;
      }
    },
    // 封装获取数据的方法
    async getProduct_list() {
      let attr = [];
      for (let i = 0; i < this.attr.length; i++) {
        if (this.attr[i]) {
          attr.push(this.attr[i].id);
        }
      }
      let product_list = await this.$fetch("Shop/productlist", {
        body: {
          categoryid: this.categoryid,
          shopid: this.shopid,
          page_size: 25,
          pid: this.pid,
          page: this.page,
          size: this.size,
          attr: attr.join("_"),
          sort: this.sort,
          guid: this.guid,
          keyword: this.keyword == "undefined" ? "" : this.keyword
        }
      });
      if (product_list.attrlist) {
        for (let i = 0; i < product_list.attrlist.length; i++) {
          // product_list.attrlist[i].values.push({id:"",name:"全部"})
          if (this.attr.length > 0) {
            product_list.attrlist[i].ids = this.attr[i];
          } else {
            product_list.attrlist[i]["ids"] = "";
          }
        }
      }
      product_list.per_page = parseInt(product_list.per_page);
      for (let i = 0; i < product_list.data.length; i++) {
        product_list.data[i]["num"] = 1;
      }
      this.product_list = product_list;
      this.total = product_list.total;
      if (this.total == 0) {
        this.$message.warning("暂无数据");
      }
    },
    // 加入购物车
    async addCart(item) {
      console.log(item);
      if (item.showsign && !item.issign) {
        this.$alert("非签约产品，请勿下单", "温馨提示", {
          confirmButtonText: "继续加入购物车",
          callback: async action => {
            this.goodscarqianyue(item);
          }
        });
      } else {
        this.goodscarqianyue(item);
      }
    },
    async goodscarqianyue(item) {
      let res = await this.$fetch("Cart/edit", {
        body: {
          productid: item.id,
          num: item.num
        }
      });
      if (res) {
        this.cartnum = res;
        this.$message.success("加入购物车成功");
      }
    },
    // 排序
    changeSort(sort) {
      console.log("sort", sort);
      this.sort = sort;
      this.getProduct_list();
    },
    currentPage(e) {
      this.page = e;
    },
    navclass(e) {
      this.categoryid = e;
    }
  },
  async mounted() {
    let hashurl = location.hash;
    this.hashurl = hashurl;
    this.indexData = await this.$fetch("Index/indexdata");
    this.cartnum = this.indexData.index_cartnum;
    this.getProduct_list();
    // 猜你喜欢
    this.cainixihuan = await this.$fetch("Shop/productlist", {
      body: {
        page: 1,
        size: 5,
        guid: "",
        guess: 1
      }
    });
    if (sessionStorage.user) {
      this.userInfo = JSON.parse(sessionStorage.user);
    }
    setTimeout(() => {
      $(".item .ft").on("click", function() {
        $(this)
          .parent()
          .children(".bd")
          .toggleClass("open");
        $(this)
          .children(".openbtn,.closebtn")
          .toggle();
      });
    }, 100);

    $(".nav-service").hover(
      function() {
        $(this)
          .find(".downmenu")
          .slideDown("fast");
      },
      function() {
        $(this)
          .find(".downmenu")
          .stop()
          .slideUp("fast");
      }
    );
  }
};
</script>


<style lang='scss' scoped>
.topguanggao {
  width: 100%;
}
.el-carousel__item {
  height: 450px;
}
.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
.el-carousel__indicators {
  .el-carousel__indicator {
    margin-right: 10px !important;
  }
}

/* .el-carousel__indicator {
	  background: red;
  } */
</style>



// WEBPACK FOOTER //
// src/pages/goodsList.vue